/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ref.vue?vue&type=template&id=9179a4f2&scoped=true"
import script from "./ref.vue?vue&type=script&lang=js"
export * from "./ref.vue?vue&type=script&lang=js"
import style0 from "./ref.vue?vue&type=style&index=0&id=9179a4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9179a4f2",
  null
  
)

export default component.exports